import useAuctionCountdown from '@/pages/artwork/hooks/useAuctionCountdown';

import './styles/AuctionTimeLeftIndicator.css';

/**
 * Tiny reusable badge that highlights how much time remains in the auction.
 * Colours transition from the default brand tone → yellow (last hour) → red (last 5 min).
 */
export default function AuctionTimeLeftIndicator({
  endsAt,
  className = '',
  serverTimeOffsetMs = 0,
  isFrozen = false,
}) {
  const { label, status } = useAuctionCountdown(endsAt, {
    serverTimeOffsetMs,
    freeze: isFrozen,
  });

  if (!endsAt || !label) {
    return null;
  }

  const classes = [
    'auction-time-indicator',
    status ? `auction-time-indicator--${status}` : '',
    isFrozen ? 'auction-time-indicator--stale' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const showLiveBadge = status === 'running';

  return (
    <span className={classes} aria-live="polite">
      {showLiveBadge ? (
        <span className="auction-time-indicator__live-pill" aria-hidden="true">
          <span className="auction-time-indicator__live-dot" />
          <span className="auction-time-indicator__live-text">Live Auction</span>
        </span>
      ) : null}
      <span className="auction-time-indicator__label">{label}</span>
    </span>
  );
}
